// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AlbumPhotosFormController from "./album_photos_form_controller"
application.register("album-photos-form", AlbumPhotosFormController)

import AllergyItemsController from "./allergy_items_controller"
application.register("allergy-items", AllergyItemsController)

import FreeSpaceInfoCategoriesController from "./free_space_info_categories_controller"
application.register("free-space-info-categories", FreeSpaceInfoCategoriesController)

import FreeSpaceInfoCategoryController from "./free_space_info_category_controller"
application.register("free-space-info-category", FreeSpaceInfoCategoryController)

import PhotoMessageController from "./photo_message_controller"
application.register("photo-message", PhotoMessageController)

import PostalCodeToAddressController from "./postal_code_to_address_controller"
application.register("postal-code-to-address", PostalCodeToAddressController)

import SeatingPlanSettingController from "./seating_plan_setting_controller"
application.register("seating-plan-setting", SeatingPlanSettingController)

import VideoUploadStatusController from "./video_upload_status_controller"
application.register("video-upload-status", VideoUploadStatusController)
